import React from 'react';
import {
    closestCenter,
    DndContext,
    DragEndEvent,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';

import { ColumnSettingsItem } from './ColumnSettingsItem';
import { TColumnSettingsItem } from './useColumnSettingsDraft';

import styles from './TableColumnSettings.module.scss';

export interface IColumnSettingsListProps {
    items: TColumnSettingsItem[];
    visibleCount: number;
    onMove: (activeId: string, overId: string) => void;
    onToggle: (id: string) => void;
}

export const ColumnSettingsList: React.FC<IColumnSettingsListProps> = ({ items, visibleCount, onMove, onToggle }) => {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
    );

    const handleDragEnd = ({ active, over }: DragEndEvent) => {
        if (!over || active.id === over.id) return;
        onMove(String(active.id), String(over.id));
    };

    return (
        <DndContext
            collisionDetection={closestCenter}
            modifiers={[restrictToVerticalAxis, restrictToParentElement]}
            onDragEnd={handleDragEnd}
            sensors={sensors}
        >
            <SortableContext items={items} strategy={verticalListSortingStrategy}>
                <ul className={styles.list}>
                    {items.map((item) => (
                        <ColumnSettingsItem
                            key={item.id}
                            item={item}
                            locked={item.visible && visibleCount <= 1}
                            onToggle={onToggle}
                        />
                    ))}
                </ul>
            </SortableContext>
        </DndContext>
    );
};
